/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Questionnaire_Helptext1Inputs */

const en_questionnaire_helptext1 = /** @type {(inputs: Questionnaire_Helptext1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This questionnaire helps our medical team better care for your pet.`)
};

const fr_questionnaire_helptext1 = /** @type {(inputs: Questionnaire_Helptext1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce questionnaire sert à aider notre équipe médicale à mieux prendre soin de votre animal.`)
};

/**
* | output |
* | --- |
* | "This questionnaire helps our medical team better care for your pet." |
*
* @param {Questionnaire_Helptext1Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const questionnaire_helptext1 = /** @type {((inputs?: Questionnaire_Helptext1Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Questionnaire_Helptext1Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_questionnaire_helptext1(inputs)
	return fr_questionnaire_helptext1(inputs)
});
export { questionnaire_helptext1 as "questionnaire_helpText" }